import { useNow } from "../hooks/useNow";
import { ecc } from "../lib/data";
import { formatHHMM, formatRel, minutesNow } from "../lib/time";
import { Icon } from "./Icon";
import { usePendingWrites } from "../hooks/usePendingWrites";

export function TopBar({ onLock }: { onLock: () => void }) {
  const now = useNow(15_000);
  const nowMin = minutesNow(now);

  const nextEcc = ecc.find((e) => e.vanMin != null && e.vanMin > nowMin);

  return (
    <header className="sticky top-0 z-30">
      <div className="absolute inset-0 bg-ink-950/80 backdrop-blur-xl pointer-events-none" />
      <div
        className="absolute inset-x-0 bottom-0 h-px pointer-events-none"
        style={{
          background:
            "linear-gradient(to right, transparent, rgba(255,255,255,0.08) 20%, rgba(255,255,255,0.08) 80%, transparent)",
        }}
      />
      <div className="relative safe-top px-4 py-2.5 flex items-center gap-3">
        <div className="flex flex-col">
          <div className="flex items-center gap-1.5 text-2xs tracking-eyebrow uppercase text-zinc-500">
            <span className="w-1 h-1 rounded-full bg-accent" />
            18 JUL · PAL MUNDO
          </div>
          <div className="flex items-center gap-1.5">
            <div
              className="text-2xl font-semibold tabular leading-none mt-1 tracking-tight"
              style={{ fontFeatureSettings: '"ss01", "cv11"' }}
            >
              {formatHHMM(now)}
            </div>
            <SyncDot />
          </div>
        </div>
        <div className="flex-1 text-right">
          {nextEcc ? (
            <div className="inline-flex flex-col items-end">
              <div className="text-2xs tracking-eyebrow uppercase text-zinc-500">
                Volgend ECC
              </div>
              <div className="text-sm font-medium mt-0.5">
                <span className="tabular text-zinc-200">{nextEcc.tijd_van}</span>
                <span className="text-zinc-600 mx-1.5">·</span>
                <span className="text-accent tabular">
                  {formatRel(nextEcc.vanMin!, nowMin)}
                </span>
              </div>
            </div>
          ) : (
            <div className="text-2xs text-zinc-500">— geen ECC meer —</div>
          )}
        </div>
        <button
          onClick={onLock}
          aria-label="Vergrendel app"
          className="ml-2 w-11 h-11 rounded-full bg-ink-850 hover:bg-ink-800 text-zinc-400 hover:text-zinc-200 flex items-center justify-center"
          style={{
            border: "1px solid rgba(255,255,255,0.06)",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,0.04)",
          }}
        >
          <Icon.Lock />
        </button>
      </div>
    </header>
  );
}

function SyncDot() {
  const pending = usePendingWrites();
  if (!pending) return null;
  return (
    <span
      role="status"
      aria-label="Schrijfacties synchroniseren"
      title="Schrijfacties synchroniseren"
      className="w-1.5 h-1.5 rounded-full bg-accent animate-pulseSoft mt-1"
    />
  );
}
